import { withIcon } from "../Icon"

export const IconGraph = withIcon(
  '<path stroke="currentColor" fill="none" stroke-width="1.7" d="M16.625 13.125 20.75 9m-9.375 1.125 3 3M4.25 15l4.875-4.875M21.875 9a1.125 1.125 0 1 0 0-2.25 1.125 1.125 0 0 0 0 2.25ZM15.5 15.375a1.125 1.125 0 1 0 0-2.25 1.125 1.125 0 0 0 0 2.25ZM10.25 10.125a1.125 1.125 0 1 0 0-2.25 1.125 1.125 0 0 0 0 2.25ZM3.125 17.25a1.125 1.125 0 1 0 0-2.25 1.125 1.125 0 0 0 0 2.25Z"/>',
)
